<template>
  <div :style="{ width: '100%', height: '100%' }" :id="id"></div>
</template>
<script>
// import echarts from "echarts";
export default {
  props: {
    id: String,
    title: String,
    data:Array
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      let myChart = this.$echarts.init(document.getElementById(this.id));
      let option = {
        title: {
          text: this.title,
          left: "left",
          textStyle:{
            fontSize: 16
          }
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          align: "auto",
          left: "0",
          top: "30%"
        },
        series: [
          {
            labelLine:{
              show: false
            },
            label:{
              show: false
            },
            type: "pie",
            width: "300",
            radius: "75%",
            data: this.data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>
